module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/role01-6187336b7d923c7249664b4460a4a66d.png";